export const getDistributorName = (dist) => {
   return dist.split("-").map(o => o.charAt(0).toUpperCase() + o.slice(1)).join(" ");
}
export const countryList = () => {

  const list = [
    {name: "Australia", code: "au"},
    {name: "Canada", code: "ca"},
    {name: "Czech Republic", code: "cz"},
    {name: "Germany", code: "de"},
    {name: "Denmark", code: "dk"},
    {name: "Spain", code: "es"},
    {name: "Finland", code: "fi"},
    {name: "France", code: "fr"},
    {name: "Great Britain", code: "gb"},
    {name: "Italy", code: "it"},
    {name: "Norway", code: "no"},
    {name: "Poland", code: "pl"},
    {name: "Portugal", code: "pt"},
    {name: "Sweden", code: "se"},
    {name: "United States of America", code: "us"},
    {name: "New Zealand", code: "nz"},
    {name: "Malaysia", code: "my"},
    {name: "Singapore", code: "sg"},
    {name: "U.A.E", code: "ae"},
  ]
  return list;
}

export const getCountryName = (country_code) => {
  switch(country_code){
    case "au":
      return "Australia";
    case "ca":
      return "Canada";
    case "cz":
      return "Czech Republic";
    case "de":
      return "Germany";
    case "dk":
      return "Denmark";
    case "es":
      return "Spain";
    case "fi":
      return "Finland";
    case "fr":
      return "France";
    case "gb":
      return "Great Britain";
    case "it":
      return "Italy";
    case "no":
      return "Norway";
    case "pl":
      return "Poland";
    case "pt":
      return "Portugal";
    case "se":
      return "Sweden";
    case "us":
      return "United States of America";
    case "nz":
      return "New Zealand";
    case "my":
      return "Malaysia";
    case "sg":
      return "Singapore";
    case "ae":
      return "U.A.E";
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils.js